
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-profile-fashion-finder",
      function () {
        return require("private-next-pages/company-profile-fashion-finder.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company-profile-fashion-finder"])
      });
    }
  